module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsBAMAAADsqkcyAAAAHlBMVEVHcEz4tiz5ti34tiz5ti34tiz4tS36uS75ti33tSwf7mgUAAAACXRSTlMAbUnZlLNgMH1OTMNwAAAAmUlEQVQoz2OYCQcCjAg2w8AINykpecKEpygpaUCFFRgYJGHCExkYmOgg7CgoGAkTniooKDJwYUKCsCAcFLAj2AykASRDkIWRrMQhzGZsbAwMTVYghe7ABAYGZizuprYwcqSFuLg4Y4lipBAkIMzk4uJiCYx8IIUsDPI0MI1Oh3oehzAsITMwKSkFh4aGKykpoYQgM0pio7MwALfHiYK+LmucAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-qr-code.png
// module id = u7Y+
// module chunks = 1 2 3 4 5 6 7